<template>
    <div class="fixed inset-0 z-50 flex items-center justify-center">
        <div class="absolute inset-0 bg-black opacity-40" @click="$emit('close')"></div>

        <div class="bg-white rounded-lg shadow-xl max-w-xl w-full mx-4 z-10 p-6">
            <div @click="$emit('close')" class="flex float-right cursor-pointer hover:text-gray-400">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" fill="white" />
                    <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#E2E8F0" />
                    <path d="M14.625 9.375L9.375 14.625M9.375 9.375L14.625 14.625" stroke="#334155" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>

            </div>
            <div class="flex flex-col items-center  w-full justify-center">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.47301 33.206L20.0669 12.2076C21.6924 9.26351 26.3202 9.26428 27.9445 12.209L39.5277 33.2073C40.9952 35.8676 38.8651 39 35.5885 39H12.4115C9.13418 39 7.00412 35.8664 8.47301 33.206Z"
                        fill="#FECDD3" />
                    <path
                        d="M23.9985 18.4962V27.4974M20.0669 12.2076L8.47301 33.206C7.00412 35.8664 9.13418 39 12.4115 39H35.5885C38.8651 39 40.9952 35.8676 39.5277 33.2073L27.9445 12.209C26.3202 9.26428 21.6924 9.26351 20.0669 12.2076Z"
                        stroke="#F43F5E" stroke-width="2" stroke-linecap="round" />
                    <path
                        d="M25.5 32.5C25.5 33.3284 24.8284 34 24 34C23.1716 34 22.5 33.3284 22.5 32.5C22.5 31.6716 23.1716 31 24 31C24.8284 31 25.5 31.6716 25.5 32.5Z"
                        fill="#F43F5E" />
                </svg>

                
                <h2 class="text-lg pt-4 font-semibold text-gray-700">Delete Account?</h2>
            </div>

            <div class="flex flex-col justify-start items-start bg-gray-50 w-full mt-4 rounded-lg">
                <ul class="flex flex-col pl-4">
                    <li class="flex p-2">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.4168 14.0832L3.66675 9.33325" stroke="#10B981" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16.3335 6.16661L8.41675 14.0833" stroke="#10B981" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <div class="ml-2">
                            <p class="text-sm font-semibold">What gets deleted</p>
                            <ul class="mt-1 ml-4 list-disc list-inside text-sm text-gray-500">
                                <li>Your projects and the documents in them</li>
                                <li>Annotations in your projects</li>
                                <li>Comments and replies in your projects</li>
                            </ul>
                        </div>
                    </li>
                    <li class="flex p-2">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.6668 5.3335L5.3335 14.6668M5.3335 5.3335L14.6668 14.6668" stroke="#F43F5E"
                                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        <div class="ml-2">
                            <p class="text-sm font-semibold">What doesn’t get deleted</p>
                            <ul class="mt-1 ml-4 list-disc list-inside text-sm text-gray-500">
                                <li>Your contributions in projects owned by others</li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <div class="flex ml-4 p-2 justify-center mt-4 text-sm text-gray-500">Still have questions? Contact us at&nbsp;<a class="text-blue-600"
                    href="mailto:help@folia.com">help@folia.com</a></div>

            </div>

            <div class="mt-4">
                <label class="block text-base font-medium text-gray-700">Please enter your email address to
                    confirm</label>
                <input v-model="confirmEmail" type="email" :placeholder="userEmail || ''"
                    :class="['mt-1 block w-full rounded-md shadow-sm sm:text-sm p-2', showError ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500']" />
                <p v-if="showError" class="mt-2 text-sm text-red-600">Type {{ userEmail }} to continue</p>
            </div>

            <div class="mt-6 flex justify-end gap-3">
                <button @click="$emit('close')" type="button"
                    class="px-4 py-2 rounded-md bg-gray-200 text-gray-700">Cancel</button>
                <button :disabled="isBusy" @click="onDelete" type="button"
                    class="px-4 py-2 rounded-md bg-red-600 text-white disabled:opacity-50">
                    <span v-if="!isBusy">Delete account</span>
                    <span v-else>Deleting...</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import ProfileService from '../../../../service/profileService';

export default {
    name: 'DeleteAccountConfirmation',
    props: {
        userEmail: {
            type: String,
            default: ''
        }
    },
    emits: ['close', 'deleted'],
    setup(props, { emit }) {
        const confirmEmail = ref('');
        const isBusy = ref(false);
        const showError = ref(false);
        const profileService = new ProfileService();

        const canDelete = computed(() => {
            return confirmEmail.value && props.userEmail && confirmEmail.value.trim().toLowerCase() === props.userEmail.trim().toLowerCase();
        });

        const onDelete = async () => {
            // if email doesn't match, show validation error instead of proceeding
            if (!canDelete.value) {
                showError.value = true;
                return;
            }

            try {
                isBusy.value = true;
                await profileService.deleteAccount();
                emit('deleted');
                emit('close');
            } catch (error) {
                console.error('Failed to delete account', error);
                // optionally show an error toast
            } finally {
                isBusy.value = false;
            }
        };

        watch(confirmEmail, (val) => {
            if (showError.value && val && props.userEmail && val.trim().toLowerCase() === props.userEmail.trim().toLowerCase()) {
                showError.value = false;
            }
        });

        return {
            confirmEmail,
            isBusy,
            canDelete,
            onDelete,
            showError
        };
    }
};
</script>

<style scoped>
.disabled\:opacity-50:disabled {
    opacity: 0.5;
}
</style>
